import React from 'react';
import { Outlet } from 'react-router-dom';
import { selectUserProfile } from '../../features/common/auth/auth-slice';
import { useHasRole } from '../../hooks/use-has-role';
import { Error404 } from '../../pages/errors/404/Error404';
import { Roles } from '../../model/common/Roles';
import { useAppSelector } from '../../store/hooks';
import { Spinner } from '../common';

interface RoleProtectedRouteProps {
  allowedRoles: Roles[];
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ allowedRoles }) => {
  const userProfile = useAppSelector(selectUserProfile);
  const hasAccess = useHasRole(allowedRoles);

  // show spinner while user profile not loaded
  if (!userProfile) {
    return <Spinner />;
  }

  if (!hasAccess) {
    return <Error404 />;
  }

  return <Outlet />;
};

export default RoleProtectedRoute;
